// extracted by mini-css-extract-plugin
export default {"container":"Qj-z","blurb":"Rj-z","links":"Sj-z"};